export const valoresExibidosProdutos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorTags: '',
  separadorComponente: '',
  separadorObservacoes: '',

  //Específicos
  tipoProduto: 'Tipo de Produto',
  produto: 'Produto',
  umidade: 'Umidade',
  oncologico: 'Oncológico',
  acondicionamento: 'Acondicionamento',
  biologico: 'Biológico',
  status: 'Status de Distribuição',
  tags: 'Tags',
  compBasico: 'Comp. Básico',
  compEspecializado: 'Comp. Especializado',
  compEstrategico: 'Comp. Estratégico',
  usoHospitalar: 'Uso Hospitalar?',
  farmaciaPopular: 'Disponível na Farm. Popular?',
  grupoEspecializado: 'Grupo Financiamento',
  statusRename: 'Status Rename',
  codigoAtc: 'ATC',
};

export const headersProdutos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 4, key: 'status' },
  { text: 'Tipo', width: 10, key: 'tipoProduto' },
  { text: 'Básico', width: 4, key: 'compBasico' },
  { text: 'Especializado', width: 4, key: 'compEspecializado' },
  { text: 'Estratégico', width: 4, key: 'compEstrategico' },
  { text: 'Produto Farmarcêutico', width: 50, key: 'produtoFarmaceutico' },
  { text: 'Tags', width: 20, key: 'tags' },
];

export const headersIncoporacao = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status Incorp.', width: 7, key: 'statusIncorporacao' },
  { text: 'Status Pact.', width: 7, key: 'statusPactuacao' },
  { text: 'Data Incorp.', width: 5, key: 'dataIncorporacao' },
  { text: 'Portaria Incorp.', width: 7, key: 'portariaIncorporacao' },
  { text: 'Data Pact.', width: 5, key: 'dataPactuacao' },
  { text: 'Ata Pact.', width: 5, key: 'ataPactuacao' },
  { text: 'Componente AF', width: 7, key: 'componentePactuado' },
];

export const valoresExibidosIncorporacao: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorIncorporacao: '',
  separadorDocumento: '',
  separadorPactuacao: '',
  separadorDesincorporacao: '',
  separadorObservacoes: '',

  //Específicos
  statusIncorporacao: 'Status Incorporação',
  dataIncorporacao: 'Data da Incorporação',
  portariaIncorporacao: 'Portaria de Incorporação',
  linkPortariaIncorporacao: 'Link Portaria Incorp.',
  documentoTecnicoOrientador: 'Tipo de Doc. Orientador',
  dataDocumento: 'Data do Documento',
  documentoTecnicoOrientadorTitulo: 'Documento Orientador',
  documentoTecnicoOrientadorLink: 'Link do documento',
  dataDesincorporacao: 'Data de Desincorp.',
  portariaDesincorporacao: 'Portaria de Desincorp.',
  linkPortariaDesincorporacao: 'Link Portaria Desincorp.',

  statusPactuacao: 'Status Pactuação',
  ataPactuacao: 'Ata da Pactuação',
  dataPactuacao: 'Data da Pactuação',
  ataPactuacaoLink: 'Link da Ata de Pactuação',
};

export const headersOutrosSistemas = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Sistema', width: 7, key: 'statusIncorporacao' },
  { text: 'Código', width: 7, key: 'statusPactuacao' },
  { text: 'Nome do Produto', width: 60, key: 'dataIncorporacao' },
];

export const valoresExibidosOutrosSistemas: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorObservacoes: '',

  //Específicos
  outroSistema: 'Sistema',
  codigoProduto: 'Código',
  nomeProduto: 'Nome',
};

export const fieldObjectProdutosDaf = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
